<template>
  <svg viewBox="0 0 16 16" v-on="$listeners">
    <path
      d="M8 14c-4.418 0-8-4.686-8-6s3.582-6 8-6 8 4.686 8 6-3.582 6-8 6zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'password-show',
}
</script>